import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgChatPlus = (props, ref) => /* @__PURE__ */ _jsx("svg", {
	width: 20,
	height: 20,
	viewBox: "0 0 20 20",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M7.5 10H10M10 10H12.5M10 10V7.5M10 10V12.5M17.5 10C17.5 14.1421 14.1421 17.5 10 17.5C9.64027 17.5 9.28645 17.4747 8.94023 17.4257C7.93716 17.2838 7.43561 17.2129 7.30357 17.2027C7.08908 17.1862 7.16599 17.1888 6.95087 17.1905C6.81848 17.1915 6.66755 17.2023 6.36608 17.2239L4.57164 17.352C3.85713 17.4031 3.49985 17.4286 3.23268 17.3019C2.99815 17.1907 2.80928 17.0019 2.69808 16.7673C2.57142 16.5001 2.59694 16.1429 2.64797 15.4284L2.77615 13.6339C2.79769 13.3323 2.80846 13.1815 2.80949 13.0491C2.81116 12.834 2.81382 12.9109 2.79728 12.6964C2.7871 12.5644 2.71616 12.0628 2.57429 11.0598C2.52533 10.7135 2.5 10.3597 2.5 10C2.5 5.85786 5.85786 2.5 10 2.5C14.1421 2.5 17.5 5.85786 17.5 10Z",
		stroke: "#3F3F46",
		strokeWidth: 1.5,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
});
const ForwardRef = forwardRef(SvgChatPlus);
export default ForwardRef;
